<script lang="ts" setup>
import { ConfigProvider } from 'reka-ui'
import { Toaster } from './components/ui/sonner';
import { computed, useId } from 'vue'
import 'vue-sonner/style.css'
// const toasterComponent = ref<any>(null)
const useIdFunction = () => useId()!
const route = useRoute()
const isAdminDash = computed(() => route.path.startsWith('/admindash'))
const isHomeRoute = computed(() => route.path === '/')
const isPandaCoreRoute = computed(() => route.path === '/pandacore')
// The Teams landing uses the full-width layout shared by the home and PandaCore pages.
const isTeamsLandingRoute = computed(() => route.path === '/org')
const isChangelogRoute = computed(() => route.path === '/changelog')
const isFullBleedRoute = computed(() => isHomeRoute.value || isPandaCoreRoute.value || isTeamsLandingRoute.value || isChangelogRoute.value)
const usesLandingPageTemplate = computed(() => isFullBleedRoute.value && !isHomeRoute.value)
const isServiceDashboardRoute = computed(() => /^\/dashboard\/[^/]+\/?$/.test(route.path))
const usesDefaultPageTemplate = computed(() => !isAdminDash.value && !isFullBleedRoute.value)
const isProductionApi = useAPI().isProductionApi()

// loadComponents()

const i18n = useI18n()
useHead({
  htmlAttrs: {
    lang: () => i18n.locale.value,
    // style: () => {
    //   return useUserPref().workspaceMode
    //     ? `
    //     filter: grayscale(1);
    //   `
    //     : ''
    // }
  }
})


// onMounted(() => {
//   console.log('onMounted')
//   toasterComponent.value = Toaster
// })

// const AsyncToasterComponent = defineAsyncComponent(() => import('~/components/ui/toast/Toaster.vue'))

</script>

<template lang="pug">
//- div
ConfigProvider(:use-id="useIdFunction")
  div.app-container(:class="{ 'default-page-template': usesDefaultPageTemplate, 'landing-page-template': usesLandingPageTemplate }")
    DefaultHeader(v-if="!isAdminDash")
    //- Global dotted background layer
    .global-dotted-bg
    NuxtLoadingIndicator(:color="'rgb(126, 211, 33)'")
    //- client-only
    NuxtLayout
      .nuxt-page-wrap(:class="{ 'admindash-wrap': isAdminDash, 'home-page-wrap': isFullBleedRoute, 'default-page-template-wrap': usesDefaultPageTemplate, 'service-dashboard-wrap': isServiceDashboardRoute }")
        NuxtPage
    DefaultFooter(v-if="!isAdminDash")
ClientOnly
  DuoSidebarBackdrop(v-if="isHomeRoute")
  Toaster
.prod-api-frame(v-if="isProductionApi" data-testid="prod-api-frame" aria-hidden="true")
//- el-config-provider(:locale="locale")
//- client-only
//-   LazyCookieConsent
//- client-only
//-   AsyncToasterComponent(:duration="1500")
</template>

<style lang="postcss">
@reference "@/assets/css/tailwind.css";

/* App Container with gradient background */
.app-container {
  @apply relative min-h-screen;
  --landing-background: #020402;
  display: flex;
  flex-direction: column;
  isolation: isolate;
  width: 100%;
  max-width: 100vw;
  min-height: 100dvh;
}

/* Light mode - clean white background */
.app-container:not(.dark *) {
  background: var(--background);
  position: relative;
}

/* Dark mode - deep dark gradient */
.dark .app-container {
  background: transparent;
}

.light .app-container {
  --landing-background: #f4f7f9;
}

.app-container.landing-page-template {
  background-color: var(--landing-background);
}

/* Global dotted background pattern with blueish overlay */
.global-dotted-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  pointer-events: none;
  display: none;
  /* Footer-style dotted pattern with overlay */
  background:
    /* Blueish overlay */
    linear-gradient(to right,
      rgba(31, 41, 55, 0.15) 0%,
      rgba(31, 41, 55, 0.2) 50%,
      rgba(31, 41, 55, 0.15) 100%),
    /* Dot pattern */
    linear-gradient(90deg, #000 21px, transparent 1%) 50%,
    linear-gradient(#000 21px, transparent 1%) 50%,
    #444;
  background-size: 100% 100%, 22px 22px, 22px 22px, 100% 100%;
}

/* Dark mode - black dotted background */
.dark .global-dotted-bg {
  display: block;
  background:
    linear-gradient(90deg, #000 21px, transparent 1%) 50%,
    linear-gradient(#000 21px, transparent 1%) 50%,
    #444;
  background-size: 22px 22px;
}


/* Dev only: marks a page that talks to the production API. */
.prod-api-frame {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  pointer-events: none;
  border: 2px solid #dc2626;
}

/* iOS Safari clips fixed elements above its collapsed toolbar while content scrolls below it,
   so a bottom line would float above the screen edge. Touch screens get top and sides only. */
@media (pointer: coarse) {
  .prod-api-frame {
    border-bottom-width: 0;
  }
}

.nuxt-page-wrap {
  margin: 0 auto;
  box-sizing: border-box;
  width: 100%;
  min-width: 100%;
  --top-space: 56px;

  @media (max-width: 768px) {
    --top-space: 56px;
  }

  padding-top: 0;
  padding-bottom: 4rem;
  /* Space before footer transition */
  overflow: visible;
  /* Allow shadows to show */

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  flex: 1 0 auto;
  height: auto;
  /* text-align: center; */
  min-height: 0;
}

.nuxt-page-wrap.admindash-wrap {
  padding-top: 0;
  padding-bottom: 0;
  align-items: stretch;
  justify-content: flex-start;
  min-height: 100vh;
}

.nuxt-page-wrap.home-page-wrap {
  padding-bottom: 0;
}

.nuxt-page-wrap.service-dashboard-wrap {
  padding-bottom: 0;
}

@media (max-width: 520px) {
  .nuxt-page-wrap.service-dashboard-wrap {
    --top-space: 92px;
  }
}

.app-container.default-page-template {
  --dashboard-paper: #f4f7f9;
  --dashboard-surface: #ffffff;
  --dashboard-surface-soft: #f8fafc;
  --dashboard-surface-muted: #f1f5f9;
  --dashboard-surface-strong: #e2e8f0;
  --dashboard-text: #1e293b;
  --dashboard-muted: #64748b;
  --dashboard-border: rgba(51, 65, 85, 0.15);
  --dashboard-grid: rgba(51, 65, 85, 0.08);
  --dashboard-green: #2d5a27;

  background-color: var(--dashboard-paper);
  background-image:
    linear-gradient(var(--dashboard-grid) 1px, transparent 1px),
    linear-gradient(90deg, var(--dashboard-grid) 1px, transparent 1px);
  background-size: 40px 40px;
}

.nuxt-page-wrap.default-page-template-wrap {
  --background: var(--dashboard-paper);
  --foreground: var(--dashboard-text);
  --card: var(--dashboard-surface);
  --card-foreground: var(--dashboard-text);
  --popover: var(--dashboard-surface);
  --popover-foreground: var(--dashboard-text);
  --primary: var(--dashboard-green);
  --primary-foreground: #ffffff;
  --secondary: var(--dashboard-surface-muted);
  --secondary-foreground: var(--dashboard-text);
  --muted: var(--dashboard-surface-muted);
  --muted-foreground: var(--dashboard-muted);
  --accent: var(--dashboard-surface-soft);
  --accent-foreground: var(--dashboard-text);
  --border: var(--dashboard-surface-strong);
  --input: #cbd5e1;
  --ring: var(--dashboard-green);

  color: var(--dashboard-text);
}

.dark .app-container.default-page-template {
  --dashboard-paper: #020402;
  --dashboard-surface: #111311;
  --dashboard-surface-soft: #181a18;
  --dashboard-surface-muted: #20231f;
  --dashboard-surface-strong: #292c27;
  --dashboard-text: #f5f7f1;
  --dashboard-muted: #9aa198;
  --dashboard-border: rgba(255, 255, 255, 0.08);
  --dashboard-grid: rgba(126, 211, 33, 0.055);
  --dashboard-green: #7ed321;

  background-image:
    linear-gradient(180deg, rgba(2, 4, 2, 0.42) 0%, #020402 78%),
    linear-gradient(90deg, rgba(126, 211, 33, 0.05), transparent 36%, rgba(126, 211, 33, 0.04)),
    linear-gradient(var(--dashboard-grid) 1px, transparent 1px),
    linear-gradient(90deg, rgba(126, 211, 33, 0.045) 1px, transparent 1px);
  background-size: auto, auto, 48px 48px, 48px 48px;
}

.dark .nuxt-page-wrap.default-page-template-wrap {
  --background: var(--dashboard-paper);
  --foreground: var(--dashboard-text);
  --card: var(--dashboard-surface);
  --card-foreground: var(--dashboard-text);
  --popover: var(--dashboard-surface);
  --popover-foreground: var(--dashboard-text);
  --primary: var(--dashboard-green);
  --primary-foreground: #071006;
  --secondary: var(--dashboard-surface-muted);
  --secondary-foreground: var(--dashboard-text);
  --muted: var(--dashboard-surface-muted);
  --muted-foreground: var(--dashboard-muted);
  --accent: var(--dashboard-surface-soft);
  --accent-foreground: var(--dashboard-text);
  --border: var(--dashboard-border);
  --input: rgba(255, 255, 255, 0.12);
  --ring: rgba(126, 211, 33, 0.72);

}

.app-container.default-page-template > .global-dotted-bg,
.app-container.landing-page-template > .global-dotted-bg {
  display: none;
}

.nuxt-page-wrap.default-page-template-wrap:not(.service-dashboard-wrap) {
  padding-top: clamp(1rem, 2.2vw, 2rem);
}
</style>
